import { Component, OnInit } from '@angular/core';
import { ReportTerminals, emptyFields, Country, TransactionAccountTypes,
TransactionAccountTypeOptions, UsersType, appCodeValue, gstColumnName} from '../../utilities/common-file';
import { NzTableData } from '../../utilities/nz-table.adapter';
import { MerchantTransactionSearch} from '../../models/merchant-transactions';
import { DownloadService } from '../download-service';
import { Messages } from '../../utilities/message';
import { NzDrawerService } from 'ng-zorro-antd/drawer';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { AuthService } from '../../auth/auth.service';
import {countries} from '../../utilities/countries';
import { MerchantSearch } from '../../models/merchant';
import { LocationSearch } from '../../models/locations';
import { DateRange, MomentHelper } from '../../models/date';
import { ReportService } from '../../reports/report.service';
import * as moment from 'moment';
import { CommonService } from '../../utilities/common-service';
import { ViewDailyTransactionsComponent } from '../../view-details/view-daily-transactions.component';

@Component({
  selector: 'app-merchant-daily-summary',
  templateUrl: './merchant-daily-summary.component.html',
})
export class MerchantDailySummaryComponent implements OnInit {
    showDownload: string;
    loading = false;
    emptyField = emptyFields;
    country = Country;
    selectedTransaction: any;
    locationsList = [];
    selectedRateDateRange: Date[] = null;
    loginUserType = '';
    userType = UsersType;
    countries = countries;
    transactionAccountTypes = TransactionAccountTypes;
    accountTypeOptions = TransactionAccountTypeOptions;
    downloadList = [];
    totalAmount=0;
    currencySymbol='';
    totalTransactionFee=0;
    totalNetAmountTransfer=0;
    totalFlexmGst = 0;
    totalFlexmFee = 0;
    //  For drawer Close when refresh custom token fails
    notifyLogout: any;

    // For App Code
    showAppCodeFilter = false;
    appCodeOptions = [];
  gst:any = localStorage.getItem('gst');
  hst:any = localStorage.getItem('hst');
  gstColumnName = gstColumnName;
  columnName :any;

    private tableDataForMerchants: NzTableData<MerchantSearch, any> = new NzTableData<MerchantSearch, any>
    (new MerchantSearch(), 'name');

    private tableDataForLocations: NzTableData<LocationSearch, any> = new NzTableData<LocationSearch, any>
    (new LocationSearch(), 'fullName');

    private tableData: NzTableData<MerchantTransactionSearch, any> = new NzTableData<MerchantTransactionSearch, any>
    (new MerchantTransactionSearch(), 'transactionStatus');

    constructor(private transactionService: ReportService,
                private notification: NzNotificationService,
                private downloadService: DownloadService, private drawerService: NzDrawerService,
                private authService: AuthService,
                private commonService: CommonService) {

   }

  ngOnInit() {
    this.hst = (this.hst === "true");
    this.gst = (this.gst === "true");
    if(this.gst && this.hst){
      this.columnName = this.gstColumnName.hst;
      }
      if(this.gst && !this.hst){
      this.columnName = this.gstColumnName.gst;
      }
    this.loginUserType = this.authService.getRole();
    this.tableData.search.merchantId = this.authService.getMerchantId();
    if (this.authService.getLocationId()) {
      this.tableData.search.locationId = this.authService.getLocationId();
    } else {
      this.tableData.search.locationId = '';
    }
    this.getLocations();
    this.getReport();
  }

  onUpdatedOnChange(range: any[]) {
    if (range.length <= 1) { return; }
    this.tableData.search.createdDate = MomentHelper.createDateRange(range);
    this.getReport();
  }
  updateClear(range: any[]) {
    if (range.length <= 1) {
      this.tableData.search.createdDate = DateRange.empty();
      return;
  }
  }
  getLocations() {
    this.locationsList = this.authService.getLocationDetails();
  }
  getReport(startFromPageOne: boolean = true): void {
    this.loading = true;
    this.tableData.data = [];
    if (startFromPageOne) {
      this.tableData.pageIndex = 1;
    } else {
      this.tableData.pageIndex = this.tableData.pageIndex;
    }
    this.tableData.search.accountType = this.commonService.getTransactionAccountTypeWithExternalPayment(this.tableData.search.accountType);
    this.transactionService.getDailyMerchantTransactionsWithLimit(this.tableData).subscribe((response: any) => {
        this.totalAmount=response.data.totalAmount.toFixed(2);
      this.totalTransactionFee = response.data.totalCalculatedTransactionFee.toFixed(2);
      this.totalNetAmountTransfer= response.data.totalNetAmountTransfer.toFixed(2);
      this.totalFlexmGst = response.data.totalFlexmGst.toFixed(2);
      this.totalFlexmFee = response.data.totalFlexmFee.toFixed(2);
            this.loading = false;
            this.tableData.total = response.data.total;
            this.tableData.data = response.data.merchantSummaryReportTransactions;
            this.showDownload = Messages.downloadReport;
            this.currencySymbol = this.commonService.getCurrencySymbol(this.authService.getAppCode() === appCodeValue.all? '': this.authService.getAppCode());
      }, (err) => {
        this.loading = false;
        this.showDownload = '';
      });

}
onIndexChange(event) {
  this.tableData.pageIndex = event;
  this.getReport(false);
}
downloadReport() {
  if (this.tableData.search.createdDate.startDate && this.tableData.search.createdDate.endDate) {
    this.notification.info('Download Processing', 'Please Wait', {
      nzKey : 'key'
    });
    this.tableData.search.accountType = this.commonService.getTransactionAccountTypeWithExternalPayment(this.tableData.search.accountType);
    const value = {
          startDate: this.tableData.search.createdDate.startDate ? this.tableData.search.createdDate.startDate : '',
          endDate: this.tableData.search.createdDate.endDate ? this.tableData.search.createdDate.endDate : '',
          accountTypeIn: this.tableData.search.accountType ? this.tableData.search.accountType :
         [TransactionAccountTypes.qrPayment, TransactionAccountTypes.externalPayment, TransactionAccountTypes.refund],
          merchantId: this.tableData.search.merchantId ? this.tableData.search.merchantId : '',
          locationId: this.tableData.search.locationId ? this.tableData.search.locationId : '',
  };
    const filterHeaders = ['Created On', 'Location'];
    const filterData = [
    value.startDate && value.endDate ? moment(value.startDate).local().format('DD-MMM-YYYY') +
    'to ' + moment(value.endDate).local().format('DD-MMM-YYYY') : '',
  value.locationId ? this.locationsList[this.locationsList.
    findIndex(x => x.id === value.locationId)].name : 'All',
  ];
  var  gridFooter;
  var  footerData;
  if(this.gst){
     gridFooter = ['Total Amount','Total TransactionFee','Total '+this.columnName,'Total FlexM Fee','Total NetAmountTransfer']
     footerData=[
       this.currencySymbol+this.totalAmount,
      this.currencySymbol+this.totalTransactionFee,
      this.currencySymbol + this.totalFlexmGst,
      this.currencySymbol + this.totalFlexmFee,
      this.currencySymbol+this.totalNetAmountTransfer
    ]
  }else{
     gridFooter = ['Total Amount','Total TransactionFee','Total NetAmountTransfer']
     footerData=[
       this.currencySymbol+this.totalAmount,
      this.currencySymbol+this.totalTransactionFee,
      this.currencySymbol+this.totalNetAmountTransfer
    ]
  }
     // For Footer 
     
     this.transactionService.downloadMerchantDailySummaryReport(value).subscribe((response: any) => {
    this.downloadList = response.data.merchantSummaryReportTransactions;
    if (this.downloadList.length > 0) {
      var headers;
      if(this.gst){
        headers = ['Location', 'No. of Transactions', 'Transaction Amount',
        'Transaction Fee',this.columnName,'Total FlexM Fee','Net Amount Transferred', 'Created Date'];
      }else{
        headers = ['Location', 'No. of Transactions', 'Transaction Amount',
        'Transaction Fee', 'Net Amount Transferred', 'Created Date'];
      }
      // tslint:disable-next-line: max-line-length
      this.downloadService.onDownloadExcel(headers, ReportTerminals.merchantDailySummary, this.tableData.search.createdDate.startDate,
    this.tableData.search.createdDate.endDate, this.downloadList, ReportTerminals.merchantDailySummary,
    ReportTerminals.merchantDailySummary, filterHeaders, filterData,gridFooter,footerData);
    }
  });
} else {
  this.notification.error(Messages.noDateSelected, '', {
    nzKey : 'key'
  });
}
}
viewTransaction(data) {
  const drawerRefCreate = this.drawerService.create<ViewDailyTransactionsComponent, { selectedTransaction: any},
  any>({
    nzTitle: 'Transactions',
    nzContent: ViewDailyTransactionsComponent,
    nzWidth: '900px',
    nzClosable: true,
    nzContentParams: {
     selectedTransaction: data
    },
    nzBodyStyle: {
      height: 'calc(100% - 55px)',
      overflow: 'auto'
    }
  });
  //  For drawer Close when refresh custom token fails
  drawerRefCreate.afterOpen.subscribe(() => {
    this.notifyLogout = this.authService.notify.subscribe((result) => {
      if (result) {
        drawerRefCreate.close();
      }
  });
  });
  drawerRefCreate.afterClose.subscribe((data) => {
   if (data && typeof data !== null) {
   }
  });
}
getCurrency(currency) {
  const index = this.countries.findIndex(M => M.currency_code ===  currency);
  if (index !== -1) {
      return this.countries[index].currency_symbol;
  }
}
getTransactionType(mode) {
    return this.commonService.getTransactionAccountType(mode);
  }
  // tslint:disable-next-line: indent
  getColorForTransactionType(mode) {
    return this.commonService.getColorForTransactionAccountType(mode);
  }
 //  For drawer Close when refresh custom token fails
 // tslint:disable-next-line: use-lifecycle-interface
 ngOnDestroy() {
  if (this.notifyLogout) {
  this.notifyLogout.unsubscribe();
  }
}
}
